import { useQuery } from '@tanstack/react-query';

import {
  fetchAllMentions,
  QUERY_KEY_THEME_MENTIONS,
} from '../services/theme-mentions-service';

export const useThemeMentions = ({ themeId }: { themeId: string }) =>
  useQuery({
    queryKey: [QUERY_KEY_THEME_MENTIONS, themeId],
    queryFn: ({ signal }) => fetchAllMentions(themeId, signal),
  });
